module.exports = __webpack_public_path__ + "media/images/1200/REM_sleep_night_stars-69c45a8c8eddd6419c180377246be5b1.webp";